/**
 * Слой всплывающих слоёв таблицы (меню столбцов, воронка, выбор операции фильтра,
 * контекстное меню, настройки).
 *
 * По умолчанию Mantine даёт попапу 300, и внутри модалки (у неё 1000) меню
 * оказывалось под ней. Одного уровня с модалкой не хватает: её портал добавлен
 * в DOM раньше, но лежит выше по порядку — поэтому берём слой над модалкой
 * (как у попапов отладочной панели), оставляя уведомлениям 1300.
 */
export const DTB_POPUP_Z = 1100;
